import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useHistory } from 'react-router-dom';
import { message, Modal, Typography } from 'antd';
import { Auth } from 'aws-amplify';
import config from '../../config';

const IDLE_TIMER = config.app.idleTimer * 1000;
const REMAINING_TIME = 60 * 1000;
const IDLE_TIMER_MINUTES = IDLE_TIMER / 60000;

const IdleTimer = () => {
  const [remainingTime, setRemainingTime] = useState<number>(REMAINING_TIME);
  const [showModal, setShowModal] = useState<boolean>(false);
  const history = useHistory();

  const handleTimeout = () => {
    Auth.signOut();
    history.push('/');
    message.info(
      `Due to ${IDLE_TIMER_MINUTES} minutes of inactivity your session has been terminated and you’ve been logged out.`,
      5,
    );
    // eslint-disable-next-line no-console
    console.log(
      `Due to ${IDLE_TIMER_MINUTES} minutes of inactivity your session has been terminated and you’ve been logged out.`,
    );
  };

  const handleOk = () => {
    setShowModal(false);
    setRemainingTime(REMAINING_TIME);
  };

  const onIdle = () => {
    if (!showModal) {
      setShowModal(true);
    }
  };

  useIdleTimer({
    onIdle,
    timeout: IDLE_TIMER - REMAINING_TIME,
    throttle: 500,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      if (showModal) {
        setRemainingTime((state) => state - 1000);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [showModal, remainingTime]);

  useEffect(() => {
    if (remainingTime <= 0) {
      handleTimeout();
    }
  }, [remainingTime]);

  return (
    <Modal
      title="Session Timeout"
      visible={showModal}
      centered
      okText={`Stay Logged In (${Math.round(remainingTime / 1000)})`}
      cancelText="Log Off"
      closable={false}
      onOk={handleOk}
      onCancel={handleTimeout}
      maskClosable={false}
    >
      <Typography.Text>
        {`You are being timed out due to ${
          IDLE_TIMER / 60000
        } minutes of inactivity. Please choose to stay logged
        in or log off. Otherwise, you will be logged off automatically.`}
      </Typography.Text>
    </Modal>
  );
};

export default IdleTimer;
